// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"414":"17327b30","459":"7fa6b1e8","652":"e36590cf","774":"4d006657"}[chunkId] + ".chunk.js";
};